import React from 'react';
import { faCopy } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslations } from '../../../../../../../../../../../../../../../../../../../../../../hooks/useTranslations';
import { FormattedMessage } from 'react-intl';
import { Button, Tooltip } from 'reactstrap';
import useOpen from '../../../../../../../../../../../../../../../../../../../../../../hooks/useOpen';
import { useHandleApply } from './hooks/useHandleApply';

type QuestionBasedOnExistingActionProps = {
  id: string;
  onResolve: () => void;
};

const QuestionBasedOnExistingAction = ({
  id,
  onResolve,
}: QuestionBasedOnExistingActionProps) => {
  const { isOpen, toggle } = useOpen();

  const { attachPrefix } = useTranslations(
    'ConversationsAndFeedbacks.ConversationTemplates.ImportTemplateModal.Content.ConflictsStep.Validation.Response.Conflicts.QuestionActions.QuestionBasedOnExistingAction'
  );

  const handleApply = useHandleApply(id, onResolve);

  return (
    <>
      <Button
        id={`question-based-on-existing-${id}`}
        color="primary"
        onClick={handleApply}
        outline={true}
      >
        <FontAwesomeIcon icon={faCopy} />
      </Button>
      <Tooltip
        placement="top"
        isOpen={isOpen}
        target={`question-based-on-existing-${id}`}
        toggle={toggle}
      >
        <FormattedMessage id={attachPrefix('basedOnExisting')} />
      </Tooltip>
    </>
  );
};

export default QuestionBasedOnExistingAction;
